import axios from 'axios'
import ExportJsonExcel from "js-export-excel";
import { forEach } from 'lodash'



var coordtransform = require('coordtransform');

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}


// 导出Excel公用方法
export function exportMethod(data) {
  axios({
      method: data.method,
      url: `${data.url}${data.params ? '?' + data.params : ''}`,
      responseType: 'blob'
  }).then((res) => {
      const link = document.createElement('a')
      let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)

      // link.download = res.headers['content-disposition'] //下载后文件名
      link.download = data.fileName //下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
  }).catch(error => {
      this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
      })
      console.log(error)
  })
}

export function objectToParams (obj)  {
	return Object.keys(obj).map(o => {
		let value = obj[o]===null || obj[o]===undefined ? _ : obj[o];
		if(obj[o]===null || obj[o]===undefined ||o === null || o === undefined) {
			return null
		} 
		return `${o}=${value}`
	}).filter(o => o).join("&")
}
/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function bMapToQQMap(lng, lat) {
	const [longitude, latitude] = coordtransform.bd09togcj02(lng, lat)

	return {
		longitude,
		latitude
	};

}


export function QQMapTobMap(lng, lat) {
	const [longitude, latitude] = coordtransform.gcj02tobd09(lng, lat)
	return {
		longitude,
		latitude
	};

}

export function downLoadExcel(data) {
	// if (data.list.length === 0) {
	// 	message.error("当前无数据，无法生成EXCEL");
	// 	return;
	// }
	var option = {};
	let dataTable = [];
	var a = 1;
	if (data.list) {
		forEach(data.list, item => {
			let obj = {
				"序号": a++,
			};
			forEach(data.header, it => {
				obj[it.label] = item[it.name]
			});
			dataTable.push(obj)
		})
		let sheetHeader = ["序号"];
		forEach(data.header, it => {
			sheetHeader.push(it.label)
		})

		option.fileName = data.headerTitle;
		option.datas = [{
			sheetData: dataTable,
			sheetName: "sheet",
			sheetHeader: sheetHeader
		}];
		var toExcel = new ExportJsonExcel(option);
		toExcel.saveExcel();
		message.success("导出成功");
	}
}
